import AppIconBacsDebit from '@manager/components/icons/AppIconBacsDebit.vue';
import AppIconBancontact from '@manager/components/icons/AppIconBancontact.vue';
import AppIconCard from '@manager/components/icons/AppIconCard.vue';
import AppIconCurrencyExchange from '@manager/components/icons/AppIconCurrencyExchange.vue';
import AppIconEditCancel from '@manager/components/icons/AppIconEditCancel.vue';
import AppIconGiropay from '@manager/components/icons/AppIconGiropay.vue';
import AppIconIdeal from '@manager/components/icons/AppIconIdeal.vue';
import AppIconKlarna from '@manager/components/icons/AppIconKlarna.vue';
import AppIconLink from '@manager/components/icons/AppIconLink.vue';
import AppIconMonetizationOn from '@manager/components/icons/AppIconMonetizationOn.vue';
import AppIconPendingCancel from '@manager/components/icons/AppIconPendingCancel.vue';
import AppIconPendingPayment from '@manager/components/icons/AppIconPendingPayment.vue';
import AppIconRecurringPlus from '@manager/components/icons/AppIconRecurringPlus.vue';
import AppIconSepa from '@manager/components/icons/AppIconSepa.vue';
import AppIconSofort from '@manager/components/icons/AppIconSofort.vue';
import AppIconSparkles from '@manager/components/icons/AppIconSparkles.vue';
import type { Component } from 'vue';
import { h } from 'vue';
import type { IconProps, IconSet } from 'vuetify';

const customSvgNameToComponent: Record<string, Component> = {
  card: AppIconCard,
  sepa_debit: AppIconSepa,
  sofort: AppIconSofort,
  bacs_debit: AppIconBacsDebit,
  klarna: AppIconKlarna,
  ideal: AppIconIdeal,
  giropay: AppIconGiropay,
  link: AppIconLink,
  bancontact: AppIconBancontact,
  currencyExchange: AppIconCurrencyExchange,
  monetization: AppIconMonetizationOn,
  pendingCancel: AppIconPendingCancel,
  pendingPayment: AppIconPendingPayment,
  recurringPlus: AppIconRecurringPlus,
  editCancel: AppIconEditCancel,
  sparkles: AppIconSparkles,
};

export const customIcons: IconSet = {
  component: (props: IconProps) => {
    if (!props.icon) return null;
    let iconName: string | null;
    if (typeof props.icon === 'string') {
      iconName = props.icon;
    } else if (Array.isArray(props.icon)) {
      iconName = String(props.icon[0]);
    } else {
      iconName = null;
    }
    if (!iconName) return null;
    return h(customSvgNameToComponent[iconName]);
  },
};
